import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              G.M.P. Certified 
              <span className="accent-text"> Ayurvedic Solutions</span>
            </h1>
            <p className="hero-subtitle">
              Experience the healing power of Shiv Ayurvedic Pharmacy's specialized formulations. 
              From HEMA-CORDIAL for women's health to DYLOWIN for diabetes care - 
              trusted herbal medicines for complete family wellness.
            </p>
            <div className="hero-actions">
              {/* <a href="#products" className="btn btn-primary hero-btn">
                Shop Now
              </a> */}
              <a href="/about.html" className="btn btn-outline hero-btn">
                Learn More
              </a>
            </div>
            <div className="hero-features">
              <div className="feature-item">
                <div className="feature-icon">🏥</div>
                <span>G.M.P. Certified</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💊</div>
                <span>8 Specialized Products</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">👨‍⚕️</div>
                <span>7 Health Categories</span>
              </div>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="hero-product-card">
              <img
                src="/photos/gasso.jpg"
                alt="Gasso - Ayurvedic Product"
                className="product-image"
              />
              <div className="floating-badge">
                <span>Best Seller</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero-scroll-indicator">
        <div className="scroll-arrow">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 13L12 18L17 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 6L12 11L17 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <span>Scroll to explore</span>
      </div>
    </section>
  );
};

export default Hero;